import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthStore } from './auth-store';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const authStore = inject(AuthStore);

  const accessToken = authStore.getAccessToken();

  const shouldExclude = ['/login', '/logout', '/submission', '/problems'];

  const isExcluded = shouldExclude.some(path => req.url.includes(path));
  if (isExcluded || req.headers.has('authorization')) {
    return next(req);
  }

  if (accessToken) {
    const authReq = req.clone({
      setHeaders: {
        authorization: `Bearer ${accessToken}`,
      },
    });

    return next(authReq);
  } else {
    return next(req);
  }
};
